import StoreProvider from 'components/StoreProvider/StoreProvider';
import { authSelectors } from 'store/modules/auth/auth';

const { connect } = StoreProvider;

export const connectUser = connect((state) => ({
  isSignedIn: authSelectors.isSignedIn(state),
}));

export const connectDeepTrueAdmin = connect((state) => ({
  isDeepTrueAdmin: authSelectors.isDeepTrueAdmin(state),
}));

export const connectOrganizationAdmin = connect((state) => ({
  isOrganizationAdmin: authSelectors.isOrganizationAdmin(state),
}));
